


































































































































































import { computed, defineComponent, useFetch } from '@nuxtjs/composition-api'
import { ciTradesMatch } from '~/icons/source/regular/trades-match'
import TradableClassifieds from '~/components/car/trades/TradableClassifieds.vue'
import { fetchTradableClassifieds } from '~/store/modules/shared/trades/actions-types'
import { useNamespacedStore } from '~/compositions/store'
import { TRADES_NS, TradesState } from '~/store/modules/shared/trades/state'
import { capitalizeAllWords } from '~/utils/string'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons'
import { ciFolderOpen } from '~/icons/source/regular/folder-open'
import { useDep } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import RouteGuardService from '~/services/RouteGuardService'
import { ciUserPlus } from '~/icons/source/solid/user-plus'
import { useApp } from '~/compositions/app'

export default defineComponent({
  components: { TradableClassifieds },
  asyncData({ error: errorFn, $dep }) {
    const routeGuardService = $dep(RouteGuardService)

    if (!routeGuardService.userCanTrade() && !routeGuardService.userIsAnon()) {
      return errorFn({ statusCode: 401 })
    }
  },
  setup() {
    const { state, dispatch } = useNamespacedStore<TradesState>(TRADES_NS)
    const isLoading = computed(() => state.loading)
    const { isCar } = useApp()
    const tradableClassifeids = computed(() => {
      return state.tradableClassifieds
    })
    const allowedTradesMax = computed(() => {
      return state.allowedTradesMax
    })
    const maxLimitReached = computed(() => {
      return tradableClassifeids.value.length >= allowedTradesMax.value
    })
    const { getters: userGetters, state: userState } = useNamespacedStore<
      UserState
    >(USER_NS)
    const hasClassifieds = computed(() =>
      Boolean(userState.myClassifieds.length)
    )
    const legacyUrlService = useDep(LegacyUrlService)
    const isAnon = computed(() => userGetters('isSingleOrAnon'))

    useFetch(async () => {
      if (!isAnon.value) {
        if (process.server) {
          await dispatch(fetchTradableClassifieds)
        } else {
          dispatch(fetchTradableClassifieds)
        }
      }
    })

    const icons = computed(() => ({
      register: ciUserPlus
    }))
    const offerBtnText = computed(() => {
      return legacyUrlService.offerBtnText()
    })

    const offerBtnLink = computed(() => {
      return legacyUrlService.offerBtnLink()
    })
    const userRegisterLink = computed(() => {
      return legacyUrlService.getRegisterUrl({ 'from-trades': 1 })
    })

    return {
      ciTradesMatch,
      tradableClassifeids,
      maxLimitReached,
      allowedTradesMax,
      isLoading,
      offerBtnText,
      faPlusSquare,
      ciFolderOpen,
      hasClassifieds,
      offerBtnLink,
      capitalizeAllWords,
      isAnon,
      userRegisterLink,
      icons,
      isCar
    }
  }
})
